import { Reducer } from 'redux';
import { PhoneSearchState, PhoneSearchStatus } from './phoneSearchState';
import {
    PHONESEARCH_ERROR_ACTION_TYPE,
    PHONESEARCH_START_ACTION_TYPE,
    PHONESEARCH_SUCCESS_ACTION_TYPE,
    PhoneSearchAction
} from 'actions/phoneSearch/phoneSearchActionsTypes';

const initialState: PhoneSearchState = {
    results: [],
    status: PhoneSearchStatus.Initial,
    loading: false,
    error: undefined
};

export const PhoneSearchReducer: Reducer<PhoneSearchState, PhoneSearchAction> = (state = initialState, action) => {
    switch (action.type) {
        case PHONESEARCH_START_ACTION_TYPE:
            return {
                ...state,
                status: PhoneSearchStatus.Searching,
                loading: true,
                results: []
            };
        case PHONESEARCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: PhoneSearchStatus.SearchingSuccess,
                results: action.payload.results,
                loading: false
            };
        case PHONESEARCH_ERROR_ACTION_TYPE:
            return {
                ...state,
                status: PhoneSearchStatus.Error,
                error: action.payload.error,
                loading: false
            };
        default:
            return state;
    }
};

export default PhoneSearchReducer;
